export const QUICK_VIEW_GET = 'QUICK_VIEW_GET';//dashBoard Quick view get
export const CLOUD_USAGE_CREATE = 'CLOUD_USAGE_CREATE';//
export const GET_RECENT_CUSTOMERS_LIST = 'GET_RECENT_CUSTOMERS_LIST';
export const GET_RECENT_CUSTOMERS_ALL_LIST = 'GET_RECENT_CUSTOMERS_ALL_LIST';
export const ANALTTICAL_OVER_VIEW = 'ANALTTICAL_OVER_VIEW';//dashBoard analitic view get
